import { reactive } from 'vue';
import type { UnwrapRef } from 'vue';
import formatError from '@ohmsd/utils/formatError';
import { AxiosPromise, AxiosResponse } from 'axios';

type State<D = any> = {
  data: undefined | null | D,
  meta?: {
    error: object,
    pending: boolean,
    refreshing: boolean,
    request: AxiosPromise<D>,
  }
}

export default function ReactiveFetch<D = any> (request?: AxiosPromise<D>, state?: State<D>) {
  // eslint-disable-next-line new-cap
  const o = reactive<State>({
    data: state?.data || undefined,
    meta: {
      error: null,
      pending: !!request,
      refreshing: !!request && !!state?.data,
      request: request || null,
    },
  });

  request && request.then(
    (opts: AxiosResponse<D>) => {
      if (!opts)
        return console.error(`ReactiveFetch: request returned ${ JSON.stringify(opts) }`);
      const { request, config, data, ...meta } = opts;
      o.data = data;
      Object.assign(o.meta, meta, { pending: false });
    },
    (err) => {
      o.meta.error = formatError(err);
      o.meta.pending = false;
      return o.meta.error;
    },
  );

  return o;
}
